import React, { useEffect, useRef, useState } from 'react';
//*MUI
import { Box, Modal } from '@mui/material';
//*files
import cssClasses from "./ViewDiscountUnitCostModal.module.css";
import Button from '../../../Subcomponents/Button';
import Close from '../../Icons/Close';
import { addReferralDiscountAllotmentPriceDiscount, getApplicantsData, getInventoryType, getLoyaltyDiscountAmountTotal, getPANDataForLoyalty, getReferralDiscount, updateAllomentPaymentUnitCost, updateAllotmentPriceDiscountApplied, updateAllotmentPriceDiscountReferral, updateToCRMTableUnitCost } from '../../../Services/AllAllotments';
import { dismissLoader, presentLoader } from '../../../Services/loader';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '35%',
  height: 'fit-Content',
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
};

function ViewDiscountUnitCostModal({ open, handleClose, allotment,setApplyDiscountFlag }) {
  const unitCost = useRef({
    bsp: 0,
    gst: 0,
    sdr: 0,
    total: 0
  });
  const unitCostRefferal = useRef({
    bsp: 0,
    gst: 0,
    sdr: 0,
    total: 0
  });
  const [panFound, setPANFound] = useState(false);
  const [data,setData]=useState(false);
  const [isLoading, setIsLoading] = useState(false);
 
  useEffect(() => {
    getUnitDiscount();
  }, []);

  const panMatch=()=>{
  
      const updatedUnitCost = {
        bsp: 0,
        gst: 0,
        sdr: 0,
        total: 0
      }
      let total = 0
      let bsp = 0
      let gst = 0
      let sdr = 0

      const sdrCharges = ((Number(allotment?.unitcost?.bsp) > 3000000 ? (Math.ceil(Number(allotment?.registration_charges / 100)) * 100) : (Math.ceil(Number(allotment?.unitcost?.bsp / 100) / 100) * 100)) + allotment?.legal_charges)
      total =  allotment.loyaltydiscount?.discountAmount ? allotment?.unitcost?.total - allotment.loyaltydiscount?.discountAmount :allotment?.unitcost?.total - 0 ;
      // total = allotment?.unitcost?.total - 5000;

      bsp = (total - sdrCharges) / ((allotment?.projectname === "YASHONE ETERNITEE PH-2" || allotment?.mergedproject === "YASHONE ETERNITEE PH-2") ? 1.11 : (1 + Number(allotment?.unitcost?.gst / allotment?.unitcost?.bsp) + (Number(allotment.sdrpercentage) / 100)));

      gst = bsp * Number(allotment?.unitcost?.gst / allotment?.unitcost?.bsp);
      sdr = (Math.ceil(Math.round(bsp * ((allotment?.projectname === "YASHONE ETERNITEE PH-2" || allotment?.mergedproject === "YASHONE ETERNITEE PH-2") ? 0.06 : (Number(allotment.sdrpercentage) / 100))) / 100) * 100) + sdrCharges;
      let newTotal = Math.round(bsp) + Math.round(sdr) + Math.round(gst);
      updatedUnitCost.bsp = Math.round(bsp);
      updatedUnitCost.sdr = Math.round(sdr);
      updatedUnitCost.gst = Math.round(gst);
      updatedUnitCost.total = Math.round(newTotal);
      unitCost.current = updatedUnitCost;
      setData(true);
    
  }

  const referralDiscount=(referralDiscountCost)=>{
  
    const updatedRefferalUnitCost = {
      bsp: 0,
      gst: 0,
      sdr: 0,
      total: 0
    }
    let total = 0
    let bsp = 0
    let gst = 0
    let sdr = 0

    const sdrCharges = ((Number(allotment?.unitcost?.bsp) > 3000000 ? (Math.ceil(Number(allotment?.registration_charges / 100)) * 100) : (Math.ceil(Number(allotment?.unitcost?.bsp / 100) / 100) * 100)) + allotment?.legal_charges)
    total =referralDiscountCost? allotment?.unitcost?.total - referralDiscountCost : allotment?.unitcost?.total-0;
    // total = allotment?.unitcost?.total - 5000;

    bsp = (total - sdrCharges) / ((allotment?.projectname === "YASHONE ETERNITEE PH-2" || allotment?.mergedproject === "YASHONE ETERNITEE PH-2") ? 1.11 : (1 + Number(allotment?.unitcost?.gst / allotment?.unitcost?.bsp) + (Number(allotment.sdrpercentage) / 100)));

    gst = bsp * Number(allotment?.unitcost?.gst / allotment?.unitcost?.bsp);
    sdr = (Math.ceil(Math.round(bsp * ((allotment?.projectname === "YASHONE ETERNITEE PH-2" || allotment?.mergedproject === "YASHONE ETERNITEE PH-2") ? 0.06 : (Number(allotment.sdrpercentage) / 100))) / 100) * 100) + sdrCharges;
    let newTotal = Math.round(bsp) + Math.round(sdr) + Math.round(gst);
    updatedRefferalUnitCost.bsp = Math.round(bsp);
    updatedRefferalUnitCost.sdr = Math.round(sdr);
    updatedRefferalUnitCost.gst = Math.round(gst);
    updatedRefferalUnitCost.total = Math.round(newTotal);
    unitCostRefferal.current = updatedRefferalUnitCost;
    setData(true);
  
}
  
const getUnitDiscount = async () => {
   presentLoader()
    try {
      if (allotment) {
        panMatch();
       
        const [panResponse, respData] = await Promise.all([
          getPANDataForLoyalty(allotment.leadreferralcustid),
          getApplicantsData(allotment?.allotment_payment_id)
        ]);
        
        console.log()
        if (panResponse.success && respData[0]?.Applicants.length > 0) {
          const panArray = [panResponse?.data?.PAN];
          const applicantsWithPAN = respData.flatMap(entry =>
            entry.Applicants.filter(applicant =>
              applicant.applicant?.panNumber && panArray.includes(applicant.applicant.panNumber)
            )
          );
           setPANFound(applicantsWithPAN.length > 0);
        }
      }
    } catch (error) {
      console.error("Error during data fetching:", error);
    } finally {
      dismissLoader() // Set loading state to false once all API calls are done
    }
  };
  

  const updateunitCostFunction=(costUnit)=>{
  updateToCRMTableUnitCost(costUnit, allotment?.allotment_payment_id).then(async (res) => {}).catch((err) => { console.error(err); })
  updateAllomentPaymentUnitCost(costUnit, allotment?.allotment_payment_id).then(async (res) => {}).catch((err) => {console.error(err);})
  updateAllotmentPriceDiscountApplied(allotment?.allotment_payment_id).then(async (res) => {}).catch((err) => {console.error(err); })
  handleClose();
  }

  const updateunitCostFunctionReferral=(costUnit,referalAmount)=>{
    const referralDetails={
      amount: referalAmount,
      typeOfDiscount:"Referral",
		  allotmentPaymentId: allotment?.allotment_payment_id,
    }
   addReferralDiscountAllotmentPriceDiscount(referralDetails).then(async (res) => {}).catch((err) => { console.error(err); })
   updateToCRMTableUnitCost(costUnit, allotment?.allotment_payment_id).then(async (res) => {}).catch((err) => { console.error(err); })
   updateAllomentPaymentUnitCost(costUnit, allotment?.allotment_payment_id).then(async (res) => {}).catch((err) => {console.error(err);})
   updateAllotmentPriceDiscountReferral(allotment?.allotment_payment_id).then(async (res) => {}).catch((err) => {console.error(err); })



   }
  const updateReferralFunction=async()=>{
   const response =await getInventoryType(allotment?.unit_id);
   const referralResponse=await getReferralDiscount(allotment?.project_id,allotment?.wing_id,response[0].inventoryTypeId);
    referralDiscount(referralResponse[0].referralDiscount);
    updateunitCostFunctionReferral(unitCostRefferal.current,referralResponse[0].referralDiscount);
    handleClose();
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle} sx={{ color: 'black', fontSize: 'large' }}>Do You Want to Apply Loyalty Discount?</Box>
                </Box>
              </Box>
              <Box ml={'auto'} mt={1} onClick={handleClose} style={{ cursor: "pointer" }}>
                <Close width={'1.2rem'} height={'1.2rem'} />
              </Box>
            </Box>
          </Box>

            <Box width={'100%'} height={'49%'} overflow={'auto'}>
            <Box paddingX={"3rem"} backgroundColor={"#F9FAFB"}>
              
              {panFound ? <div style={{ width: "100%", height: "100%", color: "#515A6B", fontWeight: "600", fontSize: "1.6rem", lineHeight: "2.6rem" }}>
                <>
                <div className={cssClasses.ThirdDivRow}>
                  <span>old Agreement Value</span>
                  <span>{allotment?.unitcost.bsp ? "₹" + numberWithCommas(allotment?.unitcost.bsp) : "NA"}</span>
                </div>
                {/* <Divider/> */}
                <div className={cssClasses.ThirdDivRow}>
                  <span>SDR </span>
                  <span>{ allotment?.unitcost.sdr ? "₹" + numberWithCommas( allotment?.unitcost.sdr) : "NA"}</span>
                </div>
                <div className={cssClasses.ThirdDivRow}>
                  <span>GST </span>
                  <span>{ allotment?.unitcost.gst ? "₹" + numberWithCommas( allotment?.unitcost.gst) : "NA"}</span>
                </div>
                <div className={cssClasses.ThirdDivRow}>
                  <span>Unit Cost </span>
                  <span>{ allotment?.unitcost.total ? "₹" + numberWithCommas(allotment?.unitcost.total) : "NA"}</span>
                </div>
                
                <br />
                <div style={{color: "black",fontSize: "large"}}>
                  <span>After Loyalty Discount({allotment.loyaltydiscount?.discountAmount ? "₹" + numberWithCommas(allotment.loyaltydiscount?.discountAmount) : "₹0"})</span>
                </div>
                
                  <br />
                <div className={cssClasses.ThirdDivRow}>
                  <span>New Agreement Value</span>
                  <span>{unitCost?.current.bsp ? "₹" + numberWithCommas(unitCost?.current.bsp) : "NA"}</span>
                </div>
              
                <div className={cssClasses.ThirdDivRow}>
                  <span>SDR </span>
                  <span>{unitCost?.current.sdr ? "₹" + numberWithCommas(unitCost?.current.sdr) : "NA"}</span>
                </div>
                <div className={cssClasses.ThirdDivRow}>
                  <span>GST </span>
                  <span>{unitCost?.current.gst ? "₹" + numberWithCommas(unitCost?.current.gst) : "NA"}</span>
                </div>
               
                <div className={cssClasses.ThirdDivRow}>
                  <span>Unit Cost </span>
                  <span>{unitCost?.current.total ? "₹" + numberWithCommas(unitCost?.current.total) : "NA"}</span>
                </div>
               
                </>
              </div> :
                <div style={{ width: "100%", height: "100%", color: "#515A6B", fontWeight: "600", fontSize: "1.6rem", lineHeight: "2.6rem", textAlign: "center", padding: "2rem" }}>
                  <div>PAN Not Match!</div>

                </div>}
            </Box>
          </Box>

        

          <Box className={cssClasses.FooterDiv}>
            <Box className={cssClasses.flexRow}>
              <Box width={'fit-Content'} ml={'auto'}>
                <Button
                  style={{
                    color: "#fff",
                    backgroundColor: "#1570EF",
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                  }}
                  padding={'0.85rem 2.6rem'}
                  btnName={'Close'}
                  clicked={handleClose}
                />
              </Box>
              {panFound && <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: "#006AFF",
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  //   disable={ChangeUnitStatusDetails.UnitStatus === ''}
                  btnName={'Apply Discount'}
                  clicked={() => updateunitCostFunction(unitCost.current)}
                />
              </Box>}

              {!panFound && <Box width={'fit-Content'}>
                <Button
                  style={{
                    fontSize: '1.6rem',
                    lineHeight: '2.4rem',
                    color: '#FFF',
                    backgroundColor: "#006AFF",
                    borderRadius: '0.8rem',
                  }}
                  padding={'0.65rem 3.2rem'}
                  //   disable={ChangeUnitStatusDetails.UnitStatus === ''}
                  btnName={'Apply referral Discount'}
                  clicked={() => updateReferralFunction()}
                />
              </Box>}
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ViewDiscountUnitCostModal;


function numberWithCommas(x) {
  return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}
